import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Spacious 2, 3 & 4 BHK layouts with optimal space utilization",
    "Energy-efficient building design & smart home provisions",
    "Landscaped green zones & outdoor recreational areas",
  ];
  const highlights2 = [
    "Advanced security systems for total peace of mind",
    "Proximity to business hubs, highways & transit points",
    "Seamless access to education, healthcare & retail hubs",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Welcome to Adani Realty Sion - where contemporary living meets strategic
        connectivity. Situated in the heart of Mumbai's Sion area, this upcoming
        residential marvel by Adani Realty reimagines city living with
        thoughtfully designed 2, 3 & 4 BHK apartments that balance comfort and
        convenience.
        <br />
        Part of the transformative Dharavi Redevelopment Project, Adani Realty
        Sion is crafted to offer sustainable living, state-of-the-art amenities,
        and seamless access to Mumbai's business, transit, and lifestyle hubs.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
